import { render } from "./AreaTematicaSearchParams.vue?vue&type=template&id=9a40d682"
import script from "./AreaTematicaSearchParams.vue?vue&type=script&lang=ts"
export * from "./AreaTematicaSearchParams.vue?vue&type=script&lang=ts"
script.render = render

export default script